module.exports = __webpack_public_path__ + "img/patient-user.75cedc10.svg";